module.exports = "/_next/static/images/andy-fourie-e24138a3a0f7369f792c995a2ac8c1a4.jpeg";